/*
Copyright 2026 Element Creations Ltd.
SPDX-License-Identifier: AGPL-3.0-only OR LicenseRef-Element-Commercial
Please see LICENSE in the repository root for full details.
*/
const key = "call-language";
export function preferredLanguage(): string | undefined {
  try {
    const value = localStorage.getItem(key);
    return value === "ru" || value === "en" ? value : undefined;
  } catch {
    return undefined;
  }
}
export function savePreferredLanguage(language: string): void {
  try {
    if (language) localStorage.setItem(key, language);
    else localStorage.removeItem(key);
  } catch {
    /* Use the current session if storage is disabled. */
  }
}

/** Shared links must not override a standalone visitor's browser language. */
export function languageDetectionOrder(embedded: boolean): string[] {
  return embedded ? ["urlFragment", "navigator"] : ["preference", "navigator"];
}
